<template>
  <div :class="$style.appBarBtnWrapper" data-testid="appBarBtnWrapper">
    <slot></slot>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.appBarBtnWrapper {
  width: variables.$appBarBtnWidth;
  height: variables.$appBarHeight;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
